<template>
  <v-card class="job-filters mb-4">
    <v-card-title>{{ $t('filters') }}</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="filters.statuses"
            :items="statusOptions"
            :label="$t('job-manager.status')"
            :loading="loadingOptions"
            multiple
            chips
            small-chips
            deletable-chips
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="filters.types"
            :items="typeOptions"
            :label="$t('job-manager.type')"
            :loading="loadingOptions"
            multiple
            chips
            small-chips
            deletable-chips
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="filters.queues"
            :items="queueOptions"
            :label="$t('job-manager.queue')"
            :loading="loadingOptions"
            multiple
            chips
            small-chips
            deletable-chips
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            v-model="filters.jobDefinitionNames"
            :items="jobDefinitionNameOptions"
            multiple
            :label="$t('job-manager.filters.definition')"
            :loading="loadingOptions"
            chips
            small-chips
            deletable-chips
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
              v-model="filters.jobId"
              :label="$t('job-manager.job-id')"
              prepend-icon="mdi-magnify"
              clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn x-small color="primary" @click="applyFilters">{{ $t('job-manager.apply-filters') }}</v-btn>
      <v-btn x-small text @click="resetFilters">{{ $t('job-manager.reset-filters') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import JobRepository from "@repository/JobRepository";

export default {
  name: 'JobFilters',
  data() {
    return {
      filters: {
        statuses: [],
        types: [],
        queues: [],
        jobId: null,
        jobDefinitionNames: [],
      },
    };
  },

  props: {
    options: Object,
    loadingOptions: Boolean,
  },

  mounted() {

  },

  computed: {
    statusOptions() {
      return this.mapToItems(this.options?.statuses ?? []);
    },
    typeOptions() {
      return this.mapToItems(this.options?.types ?? []);
    },
    queueOptions() {
      return this.mapToItems(this.options?.queues ?? []);
    },
    jobDefinitionNameOptions() {
      return this.mapToItems(this.options?.jobDefinitionNames ?? []);
    },
  },

  methods: {
    mapToItems(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(v => {
        if (v && typeof v === 'object') {
          const value = v.value || v.id || v.code || v.name || v.key || '';
          const text = v.text || v.label || v.name || String(value);
          return { text, value };
        }
        return { text: v, value: v };
      });
    },
    applyFilters() {
      this.$emit('filter', { ...this.filters });
    },
    resetFilters() {
      this.filters = {
        statuses: [],
        types: [],
        queues: [],
        jobDefinitionNames: [],
        jobId: null,
      };
      this.$emit('filter', { ...this.filters });
    }
  }
};
</script>

<style lang="scss" scoped>
.job-filters {
  width: 100%;
}
</style>